import { Reducer } from 'redux';
import { PURGE } from 'redux-persist';
import { CategoryManagementState, CategoryManagementTypes } from './types';

const INITIAL_STATE: CategoryManagementState = {
    loading: false,
    hasError: false,
    success: false,
    error: undefined,
};

const reducer: Reducer<CategoryManagementState> = (state: CategoryManagementState = INITIAL_STATE, action) => {
    switch (action.type) {
        case PURGE:
            return { ...INITIAL_STATE };
        case CategoryManagementTypes.CREATE_CATEGORY_REQUEST:
            return { ...INITIAL_STATE, loading: true };
        case CategoryManagementTypes.CREATE_CATEGORY_SUCCESS:
            return {
                ...INITIAL_STATE,
                success: true,
            };
        case CategoryManagementTypes.CREATE_CATEGORY_FAILURE:
            return {
                ...INITIAL_STATE,
                error: action.payload.error,
                hasError: true,
            };
        case CategoryManagementTypes.CATEGORY_MANAGEMENT_CLEAR:
            return INITIAL_STATE;
        case CategoryManagementTypes.ACTIVATE_CATEGORY_RESQUEST:
            return {
                ...state,
                loading: true,
            };
        case CategoryManagementTypes.ACTIVATE_CATEGORY_SUCCESS:
            return {
                ...INITIAL_STATE,
                success: true,
            };
        case CategoryManagementTypes.ACTIVATE_CATEGORY_FAILURE:
            return {
                ...INITIAL_STATE,
                error: action.payload.error,
                hasError: true,
                success: false,
                loading: false,
            };
        case CategoryManagementTypes.INACTIVATE_CATEGORY_RESQUEST:
            return {
                ...state,
                loading: true,
            };
        case CategoryManagementTypes.INACTIVATE_CATEGORY_SUCCESS:
            return {
                ...INITIAL_STATE,
                success: true,
            };
        case CategoryManagementTypes.INACTIVATE_CATEGORY_FAILURE:
            return {
                ...INITIAL_STATE,
                error: action.payload.error,
                hasError: true,
            };
        default:
            return state;
    }
};

export default reducer;
